import { ETHNIC_BACKGROUNDS, toEthnicityArray } from '@/utils/ethnicity';
import { Check } from 'lucide-react';

/**
 * Multi-select chip picker for ethnic background.
 *
 * Props:
 *   value:      string | string[]  (legacy string OR array)
 *   onChange:   (string[]) => void (always called with array)
 *   testId?:    prefix for data-testid (default "ethnicity")
 *   compact?:   boolean — smaller chips for dense forms
 */
export default function EthnicityMultiSelect({ value, onChange, testId = 'ethnicity', compact = false }) {
  const selected = toEthnicityArray(value);
  const isSelected = (bg) => selected.includes(bg);

  const toggle = (bg) => {
    if (isSelected(bg)) onChange(selected.filter((e) => e !== bg));
    else onChange([...selected, bg]);
  };

  return (
    <div className="flex flex-wrap gap-2" data-testid={`${testId}-multiselect`}>
      {ETHNIC_BACKGROUNDS.map((bg) => {
        const on = isSelected(bg);
        return (
          <button
            key={bg}
            type="button"
            onClick={() => toggle(bg)}
            aria-pressed={on}
            className={`inline-flex items-center gap-1.5 rounded-full border transition-all ${compact ? 'px-3 py-1.5 text-xs' : 'px-3.5 py-2 text-sm'} font-outfit ${
              on
                ? 'bg-gradient-to-r from-fuchsia-500/25 via-pink-500/20 to-amber-400/15 border-fuchsia-400/60 text-white shadow-[0_0_18px_rgba(236,72,153,0.22)]'
                : 'bg-white/5 border-white/10 text-stone-300 hover:bg-white/10 hover:border-white/20'
            }`}
            data-testid={`${testId}-chip-${bg.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
          >
            {on && <Check size={compact ? 11 : 13} className="text-fuchsia-300" />}
            {bg}
          </button>
        );
      })}
    </div>
  );
}
